import "./tabs.scss";
import React, { useEffect, useState } from "react";
import StatusSelect from "../modals/c3toc3-filter";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../../../common/notification-message/notification";
import Billerspresentaional from "./billerpresentational";
import {
  getBillerList,
  getCountryList,
  deleteBillerList,
} from "../../../../service/profile-ras-service";

import BillDetailsPopup from "./../modals/biller-billpayements-modal";
import DeleteUser from "../../../settings/deleteUser";
import moment from "moment";
const Billerstab = ({ userId }) => {
  const [searchBy, setSearchBy] = useState("nickName");
  const [searchByValue, setSearchByValue] = useState("");
  const [BillerCountry, setBillerCountry] = useState("");
  const [noOfFiltersSelected, setNoOfFiltersSelected] = useState("");
  const [filtersSelected, setFiltersSelected] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState();
  const [dataLoading, setDataLoading] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showPopupModal, setShowPopupModal] = useState(false);
  const [billerdetails, setBillerdetails] = useState([]);
  const [sizeShow, setSizeShow] = useState();
  const [selectedOption, setSelectedOption] = useState([]);
  const [popupData, setPopupData] = useState([]);
  const [billerid, setBillerid] = useState("");
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [countryList, setCountryList] = useState([]);

  const request = {
    page: 1,
    size: 10,
    billerName: "",
    nickName: "",
    billerCountry: "",
    fromDate: null,
    toDate: null,
  };
  const [filterForm, setFilterForm] = useState(request);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });
  const [deleteModal, setDeleteModal] = useState(false);

  const columns = [
    {
      dataField: "date",
      text: "Date",
      sort: true,
      style: { minWidth: "100px", textAlign: "Left" },
      formatter: (cell, row) => {
        return moment((row && row.date) || null).format("DD-MM-YY  HH:mm:ss");
      },
    },
    {
      dataField: "nickName",
      text: "Nick Name",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "100px", textAlign: "center" },
    },

    {
      dataField: "billerName",
      text: " Biller Name",
      sort: false,
      style: { minWidth: "100px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },

    {
      dataField: "category",
      text: "Biller Category",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "country",
      text: " Biller Country",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "actions",
      text: "Actions",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
      formatter: (cell, row) => {
        return (
          <>
            <img
              alt="..."
              style={{
                width: "37px",
                height: "32px",
                cursor: "pointer",
                position: "relative",
                bottom: "1px",
              }}
              src={require("assets/img/icons/common/profile.png")}
              onClick={() => {
                if (row && row.id) {
                  let data = [
                    { value: `${row.billerName}`, label: "Biller" },
                    { value: `${row.billerId}`, label: "Biller ID" },
                    { value: `${row.sku}`, label: "SKU" },
                  ];
                  let ref = row.referenceFields;
                  let refId = ref.split(",");
                  let temp = refId[0] && refId[0].split("|");
                  let temp2 = refId[1] && refId[1].split("|");
                  temp &&
                    data.push({
                      value: `${temp && temp[1]}`,
                      label: `${temp && temp[0]}`,
                    });
                  temp2 &&
                    data.push({
                      value: `${temp2 && temp2[1]}`,
                      label: `${temp2 && temp2[0]}`,
                    });
                  data.push({
                    value: `${row.daysToPost}`,
                    label: "Days to post",
                  });
                  setPopupData(data);
                  setShowPopupModal(true);
                }
              }}
            />
            <i
              className="fas fa-trash-alt"
              style={{ cursor: "pointer", textAlign: "center" }}
              onClick={() => {
                if (row && row.id) {
                  setBillerid(row.id);
                  setDeleteModal(true);
                }
              }}
            />
          </>
        );
      },
    },
  ];

  const [id, setId] = useState();
  const billercountrylist = () => {
    getCountryList("BILLPAYMENT")
      .then((res) => {
        let response = res.data;
        let options =
          response &&
          response.map((list) => {
            return { value: list.code, label: list.name };
          });
        setCountryList(options);
      })

      .catch((err) => {
        setCountryList([]);
      });
  };

  useEffect(() => {
    if (userId) {
      setId(userId);
    }
  }, []);

  useEffect(() => {
    if (id) {
      getTabBillerList(filterForm, id);
      billercountrylist();
    }
  }, [id]);

  useEffect(() => {
    if (filterForm && filterForm.isFilter) {
      getTabBillerList(filterForm, id);
    }
  }, [filterForm]);

  const getTabBillerList = (request, id) => {
    request.size = sizeShow || 10;
    setDataLoading(true);
    getBillerList(request, id)
      .then((res) => {
        let billers = res.data.billers;
        setDataLoading(false);
        setBillerdetails(billers || []);

        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setDataLoading(false);
        setBillerdetails([]); // TODO -NEED TO REMOVE
      });
  };
  const onDelete = () => {
    setDeleteLoading(true);
    deleteBillerList(billerid)
      .then((res) => {
        setDeleteModal(false);
        setDeleteLoading(false);
        openNotificationWithIcon(
          notificationStrings.success,
          "Deleted Successfully"
        );
        getTabBillerList(filterForm, id);
      })
      .catch((err) => {
        setDeleteModal(false);
        setDeleteLoading(false);
      });
  };

  const handleFilter = () => {
    let request = {};
    if (searchBy === "billerName") {
      request = {
        ...filterForm,
        billerName: searchByValue,
      };
    } else if (searchBy === "nickName") {
      request = {
        ...filterForm,
        nickName: searchByValue,
      };
    }

    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || null;
    request.toDate = (toDate && moment(toDate).format("YYYY-MM-DD")) || null;
    request.isFilter = true;
    request.country = BillerCountry;
    request.page = 1;
    setFilterForm(request);
  };

  let searchByValuePlaceholder = "";
  if (searchBy === "nickName") {
    searchByValuePlaceholder = "Damon";
  } else if (searchBy === "billerName") {
    searchByValuePlaceholder = "Stefan";
  }

  const statusFilter = () => {
    setNoOfFiltersSelected(selectedOption.length);
    setShowFilterModal(false);
    setFiltersSelected(true);
    selectedOption.map((option) => {
      switch (option.label) {
        case option.label:
          setBillerCountry(option.value);
        default:
          return "";
      }
    });
  };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedOption([{ ...selectedOption }]);
    }
  };

  const resetFilter = () => {
    setSearchBy("nickName");
    request.isFilter = true;
    setFromDate(null);
    setToDate(null);
    setBillerCountry("");
    setShowPopupModal(false);
    setFiltersSelected(false);
    setSearchByValue("");
    setSelectedOption([]);
    setBillerdetails([]);
    setNoOfFiltersSelected("");
    setFilterForm(request);
  };

  return (
    <>
      <Billerspresentaional
        {...{
          searchBy,
          setSearchBy,
          setSearchByValue,
          searchByValue,
          searchByValuePlaceholder,
          handleFilter,
          setFromDate,
          fromDate,
          setToDate,
          toDate,
          setShowFilterModal,
          filtersSelected,
          resetFilter,
          noOfFiltersSelected,
          billerdetails,
          columns,
          pagination,
          setFilterForm,
          setSizeShow,
          dataLoading,
          filterForm,
        }}
      />
      <StatusSelect
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        handleChange={handleChange}
        options={countryList}
        selectedOption={selectedOption}
        statusFilter={statusFilter}
        placeholder="Biller Country"
      />
      <BillDetailsPopup
        show={showPopupModal}
        close={() => setShowPopupModal(false)}
        popupData={popupData}
        title="Biller Details"
      />
      <DeleteUser
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        onDelete={onDelete}
        deleteLoader={deleteLoading}
      />
    </>
  );
};
export default Billerstab;
